import dataService from 'services/dataService';
import { apiPatientCcmStatusLogs } from 'services/dataService/resources';

const ITEMS_PER_PAGE = 10;

const patientCcmStatusLogs = {
  state: {
    page: 1,
    pageStep: ITEMS_PER_PAGE,
    reversed: false,
    totalCount: 1,
    totalPages: 0,
    data: [],
  },
  reducers: {
    setPatientCcmStatusLogs: (state, payload) => ({
      ...state,
      data: [...payload],
    }),
    setPage: (state, payload) => ({
      ...state,
      page: payload,
    }),
    setTotalCountAndTotalPages: (state, payload) => ({
      ...state,
      totalCount: payload.totalCount,
      totalPages: payload.totalPages,
    }),
    toggleReversed: (state) => ({
      ...state,
      reversed: !state.reversed,
    }),
  },
  effects: (dispatch) => ({
    async getPatientCcmStatusLogs(patientGuid, state) {
      const { page, reversed } = state.patientCcmStatusLogs;
      const { data } = await dataService.getList(
        apiPatientCcmStatusLogs(patientGuid, page, reversed),
      );
      dispatch.patientCcmStatusLogs.setPatientCcmStatusLogs(data?.data || []);
      const totalCount = data?.count || 0;
      const totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);

      dispatch.patientCcmStatusLogs.setTotalCountAndTotalPages({
        totalCount,
        totalPages,
      });
    },
    async setPagePatientCcmStatusLogs({ pageOffset }, state) {
      const { page, totalPages } = state.patientCcmStatusLogs;
      const newPage = page + pageOffset;
      dispatch.patientCcmStatusLogs.setPage(
        newPage <= totalPages ? newPage : totalPages,
      );
    },
    async toggleOrder() {
      dispatch.patientCcmStatusLogs.toggleReversed();
      dispatch.patientCcmStatusLogs.setPage(1);
    },
  }),
};

export default patientCcmStatusLogs;
